export enum TransactionOwnerEnum {
  USER = 'USER',
  BOT = 'BOT',
}
